import { FETCH_API_BASE_URL, SUBMIT_CONTACT_FORM } from './constants'

export const submitContactForm = (fetch, base_url) => async formData => {
	return fetch(base_url + SUBMIT_CONTACT_FORM, {
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			form: formData,
		}),
	})
		.then(res => res.json())
}

export default submitContactForm(fetch, FETCH_API_BASE_URL)



// WEBPACK FOOTER //
// ./src/fetchAPI/submitContactForm.js